import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CheckoutSettingsContext } from './context.js';

const defaultSettings = {
    account: {
        createAccountRequired: false,
        implicitAccountCreation: false
    },
    consent: {
        implicitTermsAndConditions: false
    }
};
const CheckoutSettingsProvider = ({ children , settings ,  })=>{
    const value = React.useMemo(()=>swcHelpers.objectSpread({}, defaultSettings, settings)
    , [
        settings
    ]);
    return /*#__PURE__*/ React.createElement(CheckoutSettingsContext.Provider, {
        value: value
    }, children);
};

export { CheckoutSettingsProvider, defaultSettings };
//# sourceMappingURL=provider.js.map
